export const MAGNIFIER_ZOOM_POPUP_WIDTH = 500;
export const MAGNIFIER_ZOOM_POPUP_HEIGHT = 500;
export const MAGNIFIER_CURSOR_WIDTH = 190;
export const MAGNIFIER_CURSOR_HEIGHT = 190;
export const MAGNIFIER_CURSOR_OPACITY = 0.4;
